import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// import { rtdbPlugin } from 'vuefire'
// Vue.use(rtdbPlugin)

Vue.config.productionTip = false
Vue.prototype.$Ammo = window.Ammo

// import '@/assets/css/tailwind.css'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
